import React from 'react';
import type { NavbarTheme } from './types';

export const NavbarContext = React.createContext<{
  theme?: NavbarTheme;
}>({});
